import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../../environments/environment";
import { CommonHttpService } from "../../commonHttp.service";
import { LoaderService } from "../../../_shared/services/loader.service";
import { AddToCartService } from "../../../_shared/services/add-to-cart.service";
import "rxjs/add/operator/map";
import "rxjs/add/operator/first";
import { } from "jquery";
declare var $;

@Component({
  selector: "app-top-offers",
  templateUrl: "./top-offers.component.html",
  styleUrls: ["./top-offers.component.css"],
})
export class TopOffersComponent implements OnInit {
  products: any = [];
  baseUrl: any = environment.apiUrl;
  imageUrl: any = environment.imageUrl;
  cart: any = {};
  cartItems: any = [];
  quantityError: boolean = false;
  availableQuantity: number;
  showLoaderProduct: boolean = false;
  products1: any = [];
  products2: any = [];
  offerStock: any = [];
  slideraftpo: any = [];
  count: any;
  @ViewChild("#myTabContent") selectRef: ElementRef;

  constructor(
    private service: CommonHttpService,
    private addToCartService: AddToCartService,
    private router: Router,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private ngZone: NgZone
  ) {
    this.addToCartService.isCartChanged.subscribe((flag) => {
      this.cart = JSON.parse(localStorage.getItem("cart"));
      this.cartItems = this.cart != null ? this.cart.EcartItem : [];
      this.updateCart();
    });
  }

  ngOnInit() {
    console.log(window.screen.width)
    setTimeout(() => {
      if (window.screen.width > 480) {
        $("#owl-demo").owlCarousel({
          autoPlay: 2000, //Set AutoPlay to 3 seconds
          navigation: true,
          items: 5,
          itemsDesktop: [1199, 3],
          itemsDesktopSmall: [979, 3],
        });

      }
      else {
        $("#owl-demo").owlCarousel({
          autoPlay: 2000, //Set AutoPlay to 3 seconds
          // navigation: true,
          items: 5,
          itemsDesktop: [1199, 3],
          itemsDesktopSmall: [979, 3],
        });
      }
      $("#owl-demo2").owlCarousel({
        autoPlay: 3000, //Set AutoPlay to 3 seconds
        //navigation: true,
        items: 1,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [979, 3],
      });
    }, 2000);
    this.count = 0;
    // $(window).on("load", function () {
    //   $("#owl-demo").owlCarousel({
    //     autoPlay: 3000, //Set AutoPlay to 3 seconds
    //     navigation: true,
    //     items: 5,
    //     itemsDesktop: [1199, 3],
    //     itemsDesktopSmall: [979, 3],
    //   });
    // });
    // $(window).on("load", function () {
    //   $("#owl-demo2").owlCarousel({
    //     autoPlay: 3000, //Set AutoPlay to 3 seconds
    //     //navigation: true,
    //     items: 1,
    //     itemsDesktop: [1199, 3],
    //     itemsDesktopSmall: [979, 3],
    //   });
    // });
    this.cart = JSON.parse(localStorage.getItem("cart"));
    this.cartItems = this.cart != null ? this.cart.EcartItem : [];
    setTimeout(() => {
      this.loadData();
    }, 1);
  }
  nextpage(product) {
    console.log(product);
    window.location.href = "product/" + product;
  }

  loadData() {
    this.showLoaderProduct = true;
    this.service
      .get(this.baseUrl + "OfferAPI/GetBestOffersProductList")
      .subscribe(
        (data) => {
          console.log(data);
          this.products = data;

          for (var i = 0; i < this.products.length; i++) {
            for (var j = 0; j < this.offerStock.length; j++) {
              if (this.offerStock[j].productId == this.products[i].productId) {
                this.products[i].totalStock = this.offerStock[j].stock;
                this.offerStock.splice(j, 1);
              }
            }
            //  i < 10
            this.products1.push(this.products[i])
            //  : this.products2.push(this.products[i]);
          }
          console.log(this.products);
          this.updateCart();
          this.showLoaderProduct = false;
        },
        (error) => {
          this.showLoaderProduct = false;
        }
      );
    this.service
      .get(this.baseUrl + "SliderAPI/GetExtraSliderBanners/?id=21")
      .subscribe((data) => {
        console.log(data);
        this.slideraftpo = data;
      });
  }
  routebanner(product) {
    localStorage.setItem("selectedItem", JSON.stringify(product));
    this.router.navigate(["/Banner-product-all/" + product.bannerId]);
  }

  addToCart(product) {
    product.cartQuantity = 1;
    this.addToCartService.addToCart(product);
  }

  updateCart() {
    for (var i = 0; i < this.products.length; i++) {
      this.products[i].isAddedToCart = false;
    }
    for (var i = 0; i < this.cartItems.length; i++) {
      for (var j = 0; j < this.products.length; j++) {
        if (this.cartItems[i].ProductId == this.products[j].productId) {
          this.products[j].isAddedToCart = true;
          this.products[j].cartQuantity = this.cartItems[i].Quantity;
        }
      }
    }
  }

  substractquantity(product, cartQuantity, i) {
    this.quantityError = false;
    product.cartQuantity = cartQuantity - 1;
    this.addToCartService.addToCart(product);
  }

  addQuantity(product, cartQuantity, i) {
    if (cartQuantity + 1 > product.totalStock) {
      this.quantityError = true;
      this.availableQuantity = product.totalStock;
      product.cartQuantity = cartQuantity;
    } else {
      this.quantityError = false;
      product.cartQuantity = cartQuantity + 1;
    }
    this.addToCartService.addToCart(product);
  }

  onQuantityChange(product, cartQuantity, i) {
    if (cartQuantity > product.totalStock) {
      this.quantityError = true;
      this.availableQuantity = product.totalStock;
      product.cartQuantity = product.totalStock;
    } else {
      this.quantityError = false;
      product.cartQuantity = cartQuantity;
    }
    this.addToCartService.addToCart(product);
  }
}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/home/top-offers/top-offers.component.ts